'use client';

import React from 'react';
import { Breadcrumb, BreadcrumbItem, Grid, Column } from '@carbon/react';
import { useBreadcrumbItems } from './generateBreadcrumbItems';
import '@/app/styles/breadcrumbs-carbon.scss';
export interface BreadcrumbItemType {
  label: string;
  href?: string;
  isCurrentPage?: boolean;
}

export interface CarbonBreadcrumbProps {
  items?: BreadcrumbItemType[];
  title?: string;
  fullWidth?: boolean;
  noTrailingSlash?: boolean;
  columnProps?: {
    sm?: number;
    md?: number;
    lg?: number;
  };
}

const CarbonBreadcrumb: React.FC<CarbonBreadcrumbProps> = ({
  items,
  title,
  fullWidth = true,
  noTrailingSlash = true,
  columnProps = { sm: 4, md: 8, lg: 12 },
}) => {
  const generatedItems = useBreadcrumbItems(title ?? '');
  const breadcrumbItem = items && items.length > 0 ? items : generatedItems;

  return (
    <Grid fullWidth={fullWidth} className="no-margin breadcrumnb-margin">
      <Column {...columnProps}>
        <Breadcrumb noTrailingSlash={noTrailingSlash}>
          {breadcrumbItem.map((item, i) => (
            <BreadcrumbItem
              key={i}
              href={!item.isCurrentPage ? item.href : undefined}
              isCurrentPage={item.isCurrentPage}
            >
              {item.label}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
      </Column>
    </Grid>
  );
};

export default CarbonBreadcrumb;
